export default function Logo({ size = "md", variant = "default" }) {
  const cls = size === "sm" ? "h-7" : size === "lg" ? "h-12" : "h-9";
  return (
    <div className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg viewBox="0 0 100 100" className={cls} xmlns="http://www.w3.org/2000/svg">
        <rect width="100" height="100" rx="22" fill="#0D0D10" stroke="#2D2D35" />
        {/* Letter "E" stroke */}
        <path d="M28 22h44v12H40v14h28v12H40v14h32v12H28z" fill="#E50914" />
      </svg>
      <div className="leading-none">
        <div className="font-display text-[17px] tracking-tight">
          Ethic<span className="text-[#E50914]">HR</span>
        </div>
        <div className="text-[9px] tracking-[0.34em] uppercase text-zinc-500 mt-0.5">
          {variant === "tagline" ? "Workforce Intelligence" : "Platform"}
        </div>
      </div>
    </div>
  );
}
